import { useTranslation } from 'react-i18next'
import { SUPPORTED_LANGUAGES, currentLanguage, setLanguage, type Language } from '../i18n'

const LABELS: Record<Language, string> = {
  sk: 'SK',
  cs: 'CZ',
  en: 'EN',
}

export default function LanguageSwitcher() {
  // Prekreslenie po zmene jazyka zabezpecuje useTranslation.
  const { t } = useTranslation()
  const current = currentLanguage()

  return (
    <div className="flex gap-1" role="group" aria-label={t('a11y.language')}>
      {SUPPORTED_LANGUAGES.map((lang) => {
        const active = current === lang
        return (
          <button
            key={lang}
            onClick={() => setLanguage(lang)}
            aria-pressed={active}
            lang={lang}
            // Názov jazyka je vždy v tomto jazyku (lng), nie v jazyku stránky; viditeľný kód zostáva na začiatku názvu (WCAG 2.5.3).
            aria-label={`${LABELS[lang]} – ${t(`lang.${lang}`, { lng: lang })}`}
            className={`px-3 py-1.5 rounded-lg text-xs font-medium transition ${
              active
                ? 'text-blue-950 bg-white/70 border border-blue-200/60'
                : 'text-blue-900 hover:text-blue-950 hover:bg-white/55 border border-blue-300'
            }`}
          >
            {LABELS[lang]}
          </button>
        )
      })}
    </div>
  )
}
